var _circle, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReaction4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_1465",
    "data-name": "Group 1465",
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.916,
    height: 22.916,
    viewBox: "0 0 22.916 22.916",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_80",
    "data-name": "Ellipse 80",
    cx: 11.458,
    cy: 11.458,
    r: 11.458,
    transform: "translate(0 0)",
    fill: "#ffc905"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1463",
    "data-name": "Group 1463",
    transform: "translate(6.386 7.272)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_81",
    "data-name": "Ellipse 81",
    cx: 1.085,
    cy: 1.927,
    rx: 1.085,
    ry: 1.927,
    transform: "translate(7.973)",
    fill: "#242424"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_82",
    "data-name": "Ellipse 82",
    cx: 1.085,
    cy: 1.927,
    rx: 1.085,
    ry: 1.927,
    fill: "#242424"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1464",
    "data-name": "Group 1464",
    transform: "translate(6.56 14.31)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2147",
    "data-name": "Path 2147",
    d: "M1078.814,484.835l0-.012-1.734-.451c.033-.126.848-3.085,4.9-3.085a5.079,5.079,0,0,1,3.9,1.494,3.783,3.783,0,0,1,.912,1.621l-1.749.389,0,.013c-.045-.177-.516-1.726-3.07-1.726C1079.4,483.079,1078.866,484.655,1078.814,484.835Z",
    transform: "translate(-1077.083 -481.287)",
    fill: "#242424"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReaction4);
export default __webpack_public_path__ + "static/media/reaction4.516bb0e89f5e47a1db3c2e88a908872f.svg";
export { ForwardRef as ReactComponent };